import { beneficiariesForm, PEPForm } from './beneficiariesForm';

export enum BeneficiariesActionTypes {
  ADD,
  REMOVE,
  SET,
  UPDATEITEM,
}
export interface AddBeneficiaries {
  type: BeneficiariesActionTypes.ADD;
  payload: beneficiariesForm;
}

export interface RemoveBeneficiaries {
  type: BeneficiariesActionTypes.REMOVE;
  payload: beneficiariesForm;
}

export interface SetBeneficiaries {
  type: BeneficiariesActionTypes.SET;
  payload: beneficiariesForm[];
}
export interface UpdateBeneficiary {
  type: BeneficiariesActionTypes.UPDATEITEM;
  payload: beneficiariesForm;
}

export interface PepAction {
  type: 'SAVE_PEP';
  payload: PEPForm;
}
export interface PepReset {
  type: 'RESET_PEP';
}
export type BeneficiariesActions = AddBeneficiaries | RemoveBeneficiaries | SetBeneficiaries | UpdateBeneficiary;

export type PepActions = PepAction | PepReset;
